import {
  toValidFontPair,
  toValidPalette,
} from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/config/utils';
import { useWeddingWebsiteData } from '../data/data-context';
import { DataProviderGuest } from '../data/data-provider-guest';
import { DataProviderPanel } from '../data/data-provider-panel';
import { WeddingWebsitePrimary } from './wedding-website-primary';
import { Container } from '@bridebook/ui';
import FooterBottom from '@bridebook/web/app-shared/components/footer/footer-bottom/footer-bottom';
import { DesktopPreviewDevice } from '@bridebook/web/lib/wedding-website/desktop/types';

type PanelProps = {
  dataProvider: 'panel';
  editMode: boolean;
  isSidebarEditor: boolean;
  activePreviewDevice: DesktopPreviewDevice;
};
type GuestProps = {
  dataProvider: 'guest';
  editMode?: never;
  isSidebarEditor?: never;
};

type CommonProps = {
  withFooter?: boolean;
};

type Props = (PanelProps | GuestProps) & CommonProps;

export const WeddingWebsitePrimaryWithData = (props: Props) => {
  if (props.dataProvider === 'panel') {
    return (
      <DataProviderPanel
        editMode={props.editMode}
        isSidebarEditor={props.isSidebarEditor}
        activePreviewDevice={props.activePreviewDevice}>
        <WeddingWebsiteWrapped />
        {props.withFooter && (
          <Container>
            <FooterBottom localeSelect={null} />
          </Container>
        )}
      </DataProviderPanel>
    );
  }

  return (
    <DataProviderGuest>
      <WeddingWebsiteWrapped />
    </DataProviderGuest>
  );
};

const WeddingWebsiteWrapped = () => {
  const { website } = useWeddingWebsiteData();

  return (
    <WeddingWebsitePrimary
      palette={toValidPalette(website.config.theme.palette)}
      fontPair={toValidFontPair(website.config.theme.font)}
    />
  );
};
